import { faAnglesLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";

function backButton({ path, text }) {
  return (
    <Link
      to={`/${path}`}
      className="flex gap-1 p-2 bg-gray-100 rounded-md hover:bg-gray-200 text-gray-700 font-semibold mt-3 mb-3"
    >
      <FontAwesomeIcon icon={faAnglesLeft} className="self-center" size="sm" />
      <span>{text}</span>
    </Link>
  );
}

export default backButton;
